// extracted by mini-css-extract-plugin
export default {"buttonContainer":"UploadWorkspace_buttonContainer__y2Qqq","bodyText":"UploadWorkspace_bodyText__q9qIB"};